import React from "react";
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
import ScrollMagic from "../plugins/ScrollMagic";
import "gsap/src/ScrollToPlugin";
import styles from "./plane.module.scss";
//import "../plugins/debug.addIndicators";

gsap.registerPlugin(MotionPathPlugin);

class Plane extends React.Component {

    componentDidMount() {
        let controller = new ScrollMagic.Controller();
        let tl = gsap.timeline();
        tl.fromTo(this.plane, 0.25, {opacity: 0}, {opacity: 1});
        tl.to(this.plane, {
            motionPath: {
                path: this.path,
                align: this.path,
                start: 0,
                end: 1,
                alignOrigin: [0.5, 0.5],
                autoRotate: 115
            },
            duration: 5,
            ease: 'power1.inOut',
            transformOrigin: '50% 50%'
        }, '-=0.25');

        new ScrollMagic.Scene({
            triggerElement: '#benefit-1',
            triggerHook: 'onEnter',
            duration: 2000,
            offset: 350
        })
            .setTween(tl)
            //.addIndicators({name: 'plane'})
            .addTo(controller);
    }

    render() {
        const DottedLine = (
            <svg width="171px" height="808px" viewBox="0 0 171 808">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeDasharray="20,20">
                    <g transform="translate(0.000000, -1718.000000)" stroke="#76B8AF">
                        <g transform="translate(0.000000, 1719.000000)">
                            <path ref={el => this.path = el} d="M0,0 C99.4689385,52.3712684 155.662383,132.351282 168.580332,239.940042 C187.957257,401.323182 2.57403967,535.610378 2.57403967,593.842569 C2.57403967,652.07476 56.3640096,631.683212 56.3640096,710 C56.3640096,762.211192 37.5760064,794.211192 0,806" id="Path-23" />
                        </g>
                    </g>
                </g>
            </svg>
        );

        const Aviao = (
            <svg ref={el => this.plane = el} width="82px" height="85px" viewBox="0 0 82 85">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-112.000000, -1845.000000)" fill="#76B8AF">
                        <path d="M148.942705,1844 C152.25275,1844 154.605181,1848.36752 156,1857.10255 L156,1872.708 L166.336193,1880.035 L166.335966,1878.19904 C166.335966,1877.14468 167.151844,1876.28087 168.186704,1876.20453 L168.335966,1876.19904 L170.335966,1876.19904 C171.390328,1876.19904 172.254131,1877.01492 172.33048,1878.04978 L172.335966,1878.19904 L172.336193,1884.287 L177.336193,1887.831 L177.335966,1885.19904 C177.335966,1884.14468 178.151844,1883.28087 179.186704,1883.20453 L179.335966,1883.19904 L181.335966,1883.19904 C182.390328,1883.19904 183.254131,1884.01492 183.33048,1885.04978 L183.335966,1885.19904 L183.336193,1892.083 L190.573452,1897.21368 C190.804919,1897.37774 190.954214,1897.63108 190.987921,1897.90907 L190.995193,1898.02953 L190.995193,1902.83465 C190.995193,1902.93679 190.979544,1903.03833 190.948792,1903.13573 C190.794387,1903.62477 190.299001,1903.9116 189.807348,1903.81694 L189.694112,1903.78825 L155.919,1893.124 L153.788694,1914.93338 L153.659,1915.413 L163.134223,1921.66273 C163.379724,1921.82465 163.539683,1922.08501 163.575837,1922.37273 L163.58364,1922.49751 L163.58364,1926.52836 C163.58364,1926.64559 163.563025,1926.76191 163.522737,1926.87201 C163.332945,1927.39066 162.758639,1927.65725 162.239989,1927.46746 L162.239989,1927.46746 L151.477,1923.529 L149.958955,1929.1796 C149.815578,1929.71295 149.266983,1930.02909 148.733633,1929.88571 C148.390399,1929.79344 148.121932,1929.52592 148.02845,1929.18301 L146.462,1923.439 L135.34365,1927.50831 C134.825001,1927.6981 134.250695,1927.43151 134.060902,1926.91286 C134.020615,1926.80277 134,1926.68645 134,1926.56921 L134,1922.53837 C134,1922.20226 134.168844,1921.88864 134.449417,1921.70359 L144.231,1915.252 L144.141196,1914.92393 L142.078,1893.123 L108.301081,1903.78825 C107.774423,1903.95453 107.212683,1903.66239 107.046401,1903.13573 C107.015649,1903.03833 107,1902.93679 107,1902.83465 L107,1898.02953 C107,1897.70529 107.157207,1897.40117 107.421741,1897.21368 L114.659,1892.083 L114.659227,1885.19904 C114.659227,1884.09447 115.554657,1883.19904 116.659227,1883.19904 L118.659227,1883.19904 C119.763796,1883.19904 120.659227,1884.09447 120.659227,1885.19904 L120.659,1887.831 L125.659,1884.287 L125.659227,1878.19904 C125.659227,1877.09447 126.554657,1876.19904 127.659227,1876.19904 L129.659227,1876.19904 C130.763796,1876.19904 131.659227,1877.09447 131.659227,1878.19904 L131.659,1880.035 L142,1872.704 L142,1857.10255 C143.318425,1848.36752 145.632659,1844 148.942705,1844 Z" id="Plane_green" transform="translate(148.997596, 1886.960122) rotate(-18.000000) translate(-148.997596, -1886.960122) " />
                    </g>
                </g>
            </svg>
        );

        return (
            <div className={styles.container}>
                <div className={styles.line}>{DottedLine}</div>
                <div className={styles.plane}>{Aviao}</div>
            </div>
        );
    }

}

export default Plane;